import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CrmSyncIntegrationResourceTypesEnum, CrmSyncSourcesEnum} from '../../../../models/api/crmSyncModel';
import {
  CrmPreviewMapping,
  CrmPreviewParentPanelId,
  popoutCrmPreviewAction,
} from '../../../../store/panels/contacts/contactsManager/crmPreview/crmPreviewActions';
import {PreviewCrmSyncBanner} from './previewCrmSyncBanner';

/*
 * Props.
 */

interface PreviewCrmSyncBannerContainerProps {
  panelId: CrmPreviewParentPanelId;
  crmSyncId: number;
  crmSyncSource: CrmSyncSourcesEnum;
  mapping: CrmPreviewMapping;
  externalListId?: string | number;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<PreviewCrmSyncBannerContainerProps>()(
  ({panelId, crmSyncId, crmSyncSource, mapping, externalListId}) => ({
    onPreviewClick: () =>
      popoutCrmPreviewAction(
        panelId,
        crmSyncId,
        crmSyncSource,
        CrmSyncIntegrationResourceTypesEnum.ACCOUNT,
        mapping,
        externalListId,
      ),
  }),
);

export const PreviewCrmSyncBannerContainer = connect(null, mapDispatchToProps)(PreviewCrmSyncBanner);
